var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 4.71387C5.52666 4.71387 5.14265 5.09797 5.14258 5.57129V9C5.14258 9.47339 5.52661 9.85742 6 9.85742C6.47339 9.85742 6.85742 9.47339 6.85742 9V5.57129C6.85735 5.09797 6.47334 4.71387 6 4.71387ZM6 2.14258C5.52661 2.14258 5.14258 2.52661 5.14258 3C5.14258 3.47339 5.52661 3.85742 6 3.85742C6.47339 3.85742 6.85742 3.47339 6.85742 3C6.85742 2.52661 6.47339 2.14258 6 2.14258Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.38060088d2f10d3222a6a84e787c1ff0.svg";
export { ForwardRef as ReactComponent };